import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'secondsToHours'
})
export class SecondsToHoursPipe implements PipeTransform {

  transform(value: number | null, full_team: boolean) {
    value = value || 0;

    const days = Math.floor(value / 86400); // 86400 segundos em um dia
    value %= 86400;
    const hours = Math.floor(value / 3600);
    value %= 3600;
    const minutes = Math.floor(value / 60);
    const sec = value % 60;

    if(full_team) return `${(days || 0).toString().padStart(2, "0") + "d "}${(hours || 0).toString().padStart(2, "0") + "h "}${(minutes || 0).toString().padStart(2, "0") + "m "}${sec.toString().padStart(2, "0") + "s"}`;
    else return `${days ? days.toString().padStart(2, "0") + "d " : ""}${hours ? hours.toString().padStart(2, "0") + "h " : ""}${minutes ? minutes.toString().padStart(2, "0") + "m " : ""}${sec >= 0 ? sec.toString().padStart(2, "0") + "s" : ""}`;
  }
}
